// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.HistoryBody_historyRoot__1\\+0J1 {
  width: 100%;
  min-height: 100vh;
  padding: 20px;
  background: #f5f5f5;
  display: flex;
  flex-direction: column;
  gap: 20px;
  font-family: "Inter", sans-serif;
}

.HistoryBody_tabs__\\+9lou {
  display: flex;
  justify-content: flex-start;
  gap: 8px;
  margin-bottom: 10px;
}

.HistoryBody_tabBtn__BtcAD {
  padding: 8px 14px;
  border: none;
  border-radius: 8px;
  background: #fff;
  box-shadow: 0 3px 8px rgba(0, 0, 0, 0.05);
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
}

.HistoryBody_tabBtn__BtcAD:hover {
  background: #f0f4ff;
  transform: translateY(-1px);
}

.HistoryBody_active__GGa-v {
  background: rgba(24, 115, 70, 1);
  color: white;
  box-shadow: 0 4px 12px rgba(152, 247, 74, 0.3);
}

/* 🔹 Content */
.HistoryBody_tabContent__txexg {
  background: #fff;
  border-radius: 16px;
  padding: 20px;
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.08);
  animation: HistoryBody_fadeIn__xRLND 0.5s ease;
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.HistoryBody_headerRow__wvLrj {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}

.HistoryBody_loading__LPBWV {
  font-size: 13px;
  color: #666;
}

.HistoryBody_tabContent__txexg h2 {
  margin: 0;
  font-size: 20px;
  font-weight: 600;
  color: rgba(24, 115, 70, 1);
}

/* 🔹 Filters */
.HistoryBody_filters__dpjBl {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(180px, 1fr));
  gap: 12px;
}

.HistoryBody_filters__dpjBl input,
.HistoryBody_filters__dpjBl select {
  padding: 10px 12px;
  border: 1px solid #dbe2f0;
  border-radius: 10px;
  outline: none;
  font-size: 14px;
  transition: 0.3s;
  background: #fff;
}

.HistoryBody_filters__dpjBl input:focus,
.HistoryBody_filters__dpjBl select:focus {
  border-color: rgba(24, 115, 70, 1);
  box-shadow: 0 0 6px rgba(88, 216, 86, 0.2);
}

/* ✅ ОБЁРТКА ДЛЯ СКРОЛЛА ТАБЛИЦЫ */
.HistoryBody_tableWrap__MGvC0 {
  width: 100%;
  max-height: 50vh;              /* <-- высота для вертикального скролла */
  overflow: auto;                 /* <-- и вертикальный, и горизонтальный */
  border-radius: 12px;
  border: 1px solid #eef2f9;
  background: #fff;
}

/* 🔹 Table */
.HistoryBody_table__kglrK {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
  min-width: 900px;               /* <-- чтобы горизонтальный скролл появлялся при узком экране */
}

.HistoryBody_table__kglrK th,
.HistoryBody_table__kglrK td {
  padding: 12px 16px;
  text-align: left;
  font-size: 14px;
  border-bottom: 1px solid #eef2f9;
  white-space: nowrap;            /* <-- чтобы строки не ломались */
}

.HistoryBody_table__kglrK thead th {
  position: sticky;               /* <-- липкая шапка */
  top: 0;
  z-index: 2;
  background: #f7f9ff;
  font-weight: 600;
  color: rgba(24, 115, 70, 1);
  border-bottom: 1px solid #e6ebf5;
}

.HistoryBody_table__kglrK tbody tr {
  transition: background 0.2s;
}

.HistoryBody_table__kglrK tbody tr:hover {
  background: #f4f7ff;
}

/* 🔹 Empty state */
.HistoryBody_empty__UgvtF {
  padding: 40px;
  text-align: center;
  color: #777;
  font-size: 15px;
  animation: HistoryBody_fadeIn__xRLND 0.6s ease;
}

/* 🔹 Animations */
@keyframes HistoryBody_fadeIn__xRLND {
  from {
    opacity: 0;
    transform: translateY(12px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/SalesPages/HistoryBody.module.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,2BAA2B;EAC3B,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,yCAAyC;EACzC,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,gCAAgC;EAChC,YAAY;EACZ,8CAA8C;AAChD;;AAEA,eAAe;AACf;EACE,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,0CAA0C;EAC1C,8CAA2B;EAC3B,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA,eAAe;AACf;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;AACX;;AAEA;;EAEE,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;;EAEE,kCAAkC;EAClC,0CAA0C;AAC5C;;AAEA,kCAAkC;AAClC;EACE,WAAW;EACX,gBAAgB,eAAe,yCAAyC;EACxE,cAAc,kBAAkB,yCAAyC;EACzE,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA,aAAa;AACb;EACE,WAAW;EACX,yBAAyB;EACzB,iBAAiB;EACjB,gBAAgB,gBAAgB,+DAA+D;AACjG;;AAEA;;EAEE,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,gCAAgC;EAChC,mBAAmB,aAAa,iCAAiC;AACnE;;AAEA;EACE,gBAAgB,gBAAgB,qBAAqB;EACrD,MAAM;EACN,UAAU;EACV,mBAAmB;EACnB,gBAAgB;EAChB,2BAA2B;EAC3B,gCAAgC;AAClC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,8CAA2B;AAC7B;;AAEA,kBAAkB;AAClB;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF","sourcesContent":[".historyRoot {\n  width: 100%;\n  min-height: 100vh;\n  padding: 20px;\n  background: #f5f5f5;\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n  font-family: \"Inter\", sans-serif;\n}\n\n.tabs {\n  display: flex;\n  justify-content: flex-start;\n  gap: 8px;\n  margin-bottom: 10px;\n}\n\n.tabBtn {\n  padding: 8px 14px;\n  border: none;\n  border-radius: 8px;\n  background: #fff;\n  box-shadow: 0 3px 8px rgba(0, 0, 0, 0.05);\n  font-size: 14px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.3s ease;\n}\n\n.tabBtn:hover {\n  background: #f0f4ff;\n  transform: translateY(-1px);\n}\n\n.active {\n  background: rgba(24, 115, 70, 1);\n  color: white;\n  box-shadow: 0 4px 12px rgba(152, 247, 74, 0.3);\n}\n\n/* 🔹 Content */\n.tabContent {\n  background: #fff;\n  border-radius: 16px;\n  padding: 20px;\n  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.08);\n  animation: fadeIn 0.5s ease;\n  display: flex;\n  flex-direction: column;\n  gap: 14px;\n}\n\n.headerRow {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n}\n\n.loading {\n  font-size: 13px;\n  color: #666;\n}\n\n.tabContent h2 {\n  margin: 0;\n  font-size: 20px;\n  font-weight: 600;\n  color: rgba(24, 115, 70, 1);\n}\n\n/* 🔹 Filters */\n.filters {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(180px, 1fr));\n  gap: 12px;\n}\n\n.filters input,\n.filters select {\n  padding: 10px 12px;\n  border: 1px solid #dbe2f0;\n  border-radius: 10px;\n  outline: none;\n  font-size: 14px;\n  transition: 0.3s;\n  background: #fff;\n}\n\n.filters input:focus,\n.filters select:focus {\n  border-color: rgba(24, 115, 70, 1);\n  box-shadow: 0 0 6px rgba(88, 216, 86, 0.2);\n}\n\n/* ✅ ОБЁРТКА ДЛЯ СКРОЛЛА ТАБЛИЦЫ */\n.tableWrap {\n  width: 100%;\n  max-height: 50vh;              /* <-- высота для вертикального скролла */\n  overflow: auto;                 /* <-- и вертикальный, и горизонтальный */\n  border-radius: 12px;\n  border: 1px solid #eef2f9;\n  background: #fff;\n}\n\n/* 🔹 Table */\n.table {\n  width: 100%;\n  border-collapse: separate;\n  border-spacing: 0;\n  min-width: 900px;               /* <-- чтобы горизонтальный скролл появлялся при узком экране */\n}\n\n.table th,\n.table td {\n  padding: 12px 16px;\n  text-align: left;\n  font-size: 14px;\n  border-bottom: 1px solid #eef2f9;\n  white-space: nowrap;            /* <-- чтобы строки не ломались */\n}\n\n.table thead th {\n  position: sticky;               /* <-- липкая шапка */\n  top: 0;\n  z-index: 2;\n  background: #f7f9ff;\n  font-weight: 600;\n  color: rgba(24, 115, 70, 1);\n  border-bottom: 1px solid #e6ebf5;\n}\n\n.table tbody tr {\n  transition: background 0.2s;\n}\n\n.table tbody tr:hover {\n  background: #f4f7ff;\n}\n\n/* 🔹 Empty state */\n.empty {\n  padding: 40px;\n  text-align: center;\n  color: #777;\n  font-size: 15px;\n  animation: fadeIn 0.6s ease;\n}\n\n/* 🔹 Animations */\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n    transform: translateY(12px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"historyRoot": `HistoryBody_historyRoot__1+0J1`,
	"tabs": `HistoryBody_tabs__+9lou`,
	"tabBtn": `HistoryBody_tabBtn__BtcAD`,
	"active": `HistoryBody_active__GGa-v`,
	"tabContent": `HistoryBody_tabContent__txexg`,
	"fadeIn": `HistoryBody_fadeIn__xRLND`,
	"headerRow": `HistoryBody_headerRow__wvLrj`,
	"loading": `HistoryBody_loading__LPBWV`,
	"filters": `HistoryBody_filters__dpjBl`,
	"tableWrap": `HistoryBody_tableWrap__MGvC0`,
	"table": `HistoryBody_table__kglrK`,
	"empty": `HistoryBody_empty__UgvtF`
};
export default ___CSS_LOADER_EXPORT___;
